import { render, staticRenderFns } from "./ServiceCallDetail.vue?vue&type=template&id=a3968704&scoped=true"
import script from "./ServiceCallDetail.vue?vue&type=script&lang=js"
export * from "./ServiceCallDetail.vue?vue&type=script&lang=js"
import style0 from "./ServiceCallDetail.vue?vue&type=style&index=0&id=a3968704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3968704",
  null
  
)

export default component.exports